<button type="button" class="dialog-close" (click)="dialogRef.close()"> <svg-icon name="cross"></svg-icon> </button>
<div class="worldwide-dialog__body">
  <p mat-dialog-title class="worldwide-dialog__title">Automated Draws</p>

  <div mat-dialog-content class="worldwide-dialog__text">
    We use a random number generator to draw the winning number. The winner is contacted directly, and all results are posted on our <a href="/draw-results" target="_blank">Results page</a>.
  </div>

  <div mat-dialog-actions class="worldwide-dialog__actions">
    <button type="button" class="button button_border button_no-shadow worldwide-dialog__close" (click)="dialogRef.close()" cdkFocusInitial>Close</button>
  </div>

</div>
